function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawLost = function UndrawLost(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1097.33 810.62",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 588.67,
    y1: 838.15,
    x2: 588.67,
    y2: 115.47,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M12.07 429.97c17.36 74.2 54.11 138.34 112.19 169.43 120.7 64.61 392.91 31.29 596.07-7a465.21 465.21 0 0 0 264.54-151.19z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M799.31 649.72s-67.65 40.8 57.03 103.59c0 0 27.46-51-2.9-92.57a40.94 40.94 0 0 0-53.12-11.64z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M800.09 648.86s57.88 44.28 56.25 104.45",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M18.31 661.72s-67.65 40.8 57.03 103.59c0 0 27.46-51-2.9-92.57a40.94 40.94 0 0 0-53.12-11.64z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M19.09 660.86s57.88 44.28 56.25 104.45",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M859.66 759.08s-21.19-72 4-124.91a113.65 113.65 0 0 0 9.19-71.3 191.13 191.13 0 0 0-10.19-33.46",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M878.35 495.95c0 8.82-16 34.39-16 34.39s-16-25.57-16-34.39a16 16 0 0 1 31.93 0zM904.74 544.79c-4.79 7.4-32.09 20.19-32.09 20.19s.5-30.14 5.29-37.54a16 16 0 0 1 26.8 17.36zM903.59 628.26c-7.87 4-37.89 1.23-37.89 1.23s15.64-25.77 23.52-29.74a16 16 0 0 1 14.38 28.51zM888.49 691.22c-7.09 5.24-37.14 7.61-37.14 7.61s11.06-28 18.15-33.29a16 16 0 0 1 19 25.67zM839.12 566.69c6.32 6.14 35.79 12.51 35.79 12.51s-7.22-29.27-13.54-35.41a16 16 0 0 0-22.25 22.9zM822.41 640.54c7.87 4 37.89 1.23 37.89 1.23s-15.64-25.77-23.52-29.74a16 16 0 1 0-14.38 28.51zM816.01 714.55c7.09 5.24 37.14 7.61 37.14 7.61s-11.06-28-18.15-33.29a16 16 0 1 0-19 25.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M878.35 495.95c0 8.82-16 34.39-16 34.39s-16-25.57-16-34.39a16 16 0 0 1 31.93 0zM904.74 544.79c-4.79 7.4-32.09 20.19-32.09 20.19s.5-30.14 5.29-37.54a16 16 0 0 1 26.8 17.36zM903.59 628.26c-7.87 4-37.89 1.23-37.89 1.23s15.64-25.77 23.52-29.74a16 16 0 0 1 14.38 28.51zM888.49 691.22c-7.09 5.24-37.14 7.61-37.14 7.61s11.06-28 18.15-33.29a16 16 0 0 1 19 25.67zM839.12 566.69c6.32 6.14 35.79 12.51 35.79 12.51s-7.22-29.27-13.54-35.41a16 16 0 0 0-22.25 22.9zM822.41 640.54c7.87 4 37.89 1.23 37.89 1.23s-15.64-25.77-23.52-29.74a16 16 0 1 0-14.38 28.51zM816.01 714.55c7.09 5.24 37.14 7.61 37.14 7.61s-11.06-28-18.15-33.29a16 16 0 1 0-19 25.67z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M908.66 760.45s-21.19-72 4-124.91a113.65 113.65 0 0 0 9.19-71.3 191.13 191.13 0 0 0-10.09-33.46",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M927.39 497.31c0 8.82-16 34.39-16 34.39s-16-25.57-16-34.39a16 16 0 0 1 31.93 0zM953.78 546.16c-4.79 7.4-32.12 20.15-32.12 20.15s.5-30.14 5.29-37.54a16 16 0 0 1 26.8 17.36zM952.66 629.63c-7.87 4-37.89 1.23-37.89 1.23s15.64-25.77 23.52-29.74a16 16 0 0 1 14.37 28.51zM937.53 692.59c-7.09 5.24-37.14 7.61-37.14 7.61s11.06-28 18.15-33.29a16 16 0 0 1 19 25.67zM888.16 568.06c6.32 6.14 35.79 12.51 35.79 12.51s-7.22-29.27-13.54-35.41a16 16 0 0 0-22.25 22.9zM871.44 641.91c7.87 4 37.89 1.23 37.89 1.23s-15.67-25.77-23.51-29.74a16 16 0 0 0-14.38 28.51zM865.04 715.92c7.09 5.24 37.14 7.61 37.14 7.61s-11.06-28-18.15-33.29a16 16 0 1 0-19 25.67z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M1077.43 80.72H965.96a9.635 9.635 0 1 1 0-19.27h19.27a9.635 9.635 0 0 1 0-19.27h-13.77a9.635 9.635 0 0 1 0-19.27h58.2c-12.91-6-28-10.27-45.38-12.51C825.64-9.98 769 3.5 749.02 17.4c-24.65 17.1-52.15 29.68-81.54 35.74-97.9 20.17-280.95 44.46-446.82-7.83-82.46-26-143.75 17.92-180.48 91.28h1056.61c-1.38-21.32-5.51-41-13.09-58.24a9.58 9.58 0 0 1-6.27 2.37zM2.66 275.1a491.06 491.06 0 0 0 4.33 129.46l978.67 35.75a460 460 0 0 0 68-103.7zm387 92.35h-19.23a9.635 9.635 0 0 1 0 19.27H258.96a9.635 9.635 0 1 1 0-19.27h19.27a9.635 9.635 0 0 1 0-19.27h-13.77a9.635 9.635 0 0 1 0-19.27h111.47a9.635 9.635 0 1 1 0 19.27h13.73a9.635 9.635 0 0 1 0 19.27zM1096.83 137.31l-1068.49 26c-13 33.41-21.61 71.19-25.59 110.34h1075.36a456.46 456.46 0 0 0 15.55-70.34c3.17-23 4.46-45.29 3.17-66zm-877.17 85.14h-19.23a9.635 9.635 0 0 1 0 19.27H88.96a9.635 9.635 0 1 1 0-19.27h19.27a9.635 9.635 0 0 1 0-19.27H94.46a9.635 9.635 0 0 1 0-19.27h111.47a9.635 9.635 0 1 1 0 19.27h13.73a9.635 9.635 0 0 1 0 19.27z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 550.33,
    cy: 777.62,
    rx: 533,
    ry: 33,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M774.44 313.8s-61.81-58.17-70.74-66.87c-3.11-3-6.05-6-8.56-8.53a33.57 33.57 0 0 0-17.73-9.29c-23.16-4.39-46.85-18.63-46.85-18.63-.13-.17-.26-.32-.38-.5a28.17 28.17 0 0 1-4.35-9.3c-.13-.49-.26-1-.37-1.52q.56-.72 1.09-1.47a7.16 7.16 0 0 0 1.17-.53c2.93-1.67 4.58-4.76 5.69-7.8 1-2.69 1.8-5.66 4.18-7.41a8.74 8.74 0 0 0 2.27-1.81 5.33 5.33 0 0 0 .53-3.09c0-6.83-1.09-12.07.5-18.73 2.54-10.66 4.87-24-3.18-31.91a28.11 28.11 0 0 0-15.16-7.55c-5.17-.82-12.82 6.22-18.06 6-13.35-.51-24.6-12.55-37.29-8.66a26.22 26.22 0 0 0-13.7 9.82c-6.26 8.92-5.66 20.46-4.76 31.1a3.87 3.87 0 0 0 .69 2.27c.47.55 1.22.84 1.68 1.39a3.37 3.37 0 0 1 .52 2.49 16.34 16.34 0 0 1-1.24 5 2 2 0 0 0-.19 1.81 1.89 1.89 0 0 0 1 .68 9.09 9.09 0 0 0 1.65.39c-.09.88-.17 1.76-.2 2.65v1.51a39.14 39.14 0 0 0 17.82 32.68c.11.72.23 1.46.34 2.23.34 2.37.65 5 .88 7.86 0 .52.08 1 .12 1.57l-.27-.55-43 21.08a21.31 21.31 0 0 0-8.67 4.25l-.85.42v.25q-.53.44-1.08.94l-37.31-42.14-87 75.52 47.84 51.51 53.76-4.48c-2.65 18.2-4.46 32.15-4.46 32.15s-9.83 42.13 37.79 34.07c-.31 26.57-11.69 70.91-11.69 70.91a23.42 23.42 0 0 0 4.63 4.57l-.27 1.81-3 20.37s-17.86 49.48-20.6 93.61-6.18 68.87-6.18 68.87l-6.18 88.27-8.69 40.36a204.06 204.06 0 0 1-49.4 39.5 6.92 6.92 0 0 0-2.8 9.48c3.52 6.06 14.35 12.35 47.15 2.27 52.2-16 47.39-15.38 47.39-15.38s.77-21.42-1.45-34.12c-.07-.38-.14-.75-.21-1.12 12.5-14.09 6.46-37 6.46-37s24.72-48.14 13-79.57c0 0-2.75-26.75 11.68-39.45.2-.18.41-.38.62-.59l.19-.2.47-.5.21-.23.55-.64.12-.14c.22-.27.45-.56.68-.86l.18-.24.58-.65.22-.32.54-.79.18-.26.73-1.11.14-.22.61-1 .23-.38.56-.94.21-.36.77-1.34.77-1.38.22-.41.59-1.09.23-.44.71-1.35.09-.17.82-1.6.2-.39.64-1.27.24-.48.67-1.36.17-.34.84-1.75.14-.29.7-1.49.24-.51.65-1.39.21-.45.86-1.87.83-1.85.23-.51.65-1.47.22-.51.89-1.91v-.08l.87-2 .19-.43.68-1.58.23-.53.71-1.69.14-.32.86-2 .14-.33.71-1.7.23-.55.65-1.59.19-.46.83-2 .07-.17.75-1.85.23-.57.61-1.52.22-.55.72-1.82.07-.19.78-2 .23-.58.56-1.43.24-.63.59-1.52.17-.45.73-1.89.2-.52.53-1.38.27-.7.47-1.22.25-.66.66-1.75.19-.51.48-1.28.27-.71.4-1.07.27-.73.45-1.21.29-.78.45-1.22.29-.78.31-.84.29-.8.25-.69.67-1.82.11-.31.31-.86.21-.57.32-.87.15-.41c2.87-7.91 4.63-13 4.63-13s13 45.47 11 59.51 12.36 66.2 12.36 66.2-8.24 52.16-3.43 64.86-6.87 60.18-6.87 60.18.89.49 2.4 1.24l-.09 1.29c-.75 10.44-2.38 30.5-4.37 38.26-2.75 10.7-1.37 22.07 20.6 20.73s22.66-14.71 22.66-14.71-7.25-23.38-8.14-37.17c0-.45 0-.89-.06-1.32l.62-.23.18-.07c.25-.11.49-.22.72-.34.22-.12.42-.24.63-.37l.18-.12q.26-.18.51-.38l.12-.1q.3-.25.57-.52l.13-.13q.21-.23.41-.47l.14-.18c.16-.21.32-.43.47-.67 7.55-12 8.24-37.45 8.24-37.45s15.11-85.59 9.62-97-2.75-38.11-2.75-38.11-6.18-40.12.69-59.51c5.14-14.52 8.36-64.66 8.21-88.65v-1.47-.51c5.12-6.36 9-17.52 6.24-37.08-.16-1.11-.28-2.23-.4-3.37 7.8-5.83 15.5-12.68 15.5-12.68l2.66-2.74.85-.88c.74.31 1.52.59 2.33.84 3 1.36 5.14 2.12 5.14 2.12s39.15-32.1 68.68-47.48 5.57-43.6 5.57-43.6zm-46.7 28.08S686.53 368 679 381.34a10 10 0 0 0-1 2.38l-1 .42-1.26.48c6.31-36 23.2-71.49 23.2-71.49s13 11.37 22 16 6.8 12.76 6.8 12.76z",
    transform: "translate(-51.34 -44.69)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M424.39 783.86c-31.64 10-42.09 3.76-45.48-2.25a7 7 0 0 1 2.7-9.39 198.05 198.05 0 0 0 48-39.54c3.52-4 5.37-6.45 5.37-6.45s24.51-4.64 30.47 0c1.49 1.16 2.53 4.4 3.24 8.6 2.14 12.58 1.4 33.8 1.4 33.8s4.64-.67-45.7 15.23zM593.96 774.58s-.66 13.25-21.86 14.57-22.52-9.94-19.87-20.53c1.92-7.68 3.49-27.55 4.21-37.9.27-3.93.42-6.48.42-6.48s33.12-3.31 29.81 6a20.65 20.65 0 0 0-.56 7.56c.86 13.63 7.85 36.78 7.85 36.78z",
    fill: "#5b5877"
  }), React.createElement("path", {
    d: "M468.66 734.83l-.59.68c-12.59 13.91-39.08 0-39.08 0l.59-2.82c3.52-4 5.37-6.45 5.37-6.45s24.51-4.64 30.47 0c1.53 1.15 2.57 4.39 3.24 8.59zM586.66 730.2a20.65 20.65 0 0 0-.56 7.56c-8.66 3-24-4.1-29.67-7 .27-3.93.42-6.48.42-6.48s33.14-3.35 29.81 5.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M607.87 599.71c5.3 11.26-9.27 96-9.27 96s-.66 25.17-7.95 37.09-36.43-4.64-36.43-4.64 11.26-47 6.62-59.62 3.31-64.23 3.31-64.23-13.91-51.67-11.92-65.58-10.6-59-10.6-59-29.15 86.78-43.06 99.36-11.26 39.08-11.26 39.08C498.57 649.3 474.72 697 474.72 697s6 23.18-6.62 37.09-39.08 0-39.08 0l8.64-40.98 6-87.44s3.31-24.51 6-68.23 19.87-92.74 19.87-92.74l2.88-20.18 2.42-16.92s134.47-4.64 137.78-5.3c.83-.17 1.25 4.89 1.29 12.86.15 23.77-3 73.43-7.92 87.82-6.62 19.21-.66 59-.66 59s-2.75 26.47 2.55 37.73z",
    fill: "#5f5d7e"
  }), React.createElement("g", {
    opacity: 0.05
  }, React.createElement("path", {
    d: "M534.35 479.81s-29.15 86.78-43.06 99.36-11.26 39.08-11.26 39.08c11.26 31.13-12.59 78.83-12.59 78.83s6 23.18-6.62 37.09a19 19 0 0 1-12.22 6c7 .73 14.39-.33 19.5-6 12.59-13.91 6.62-37.09 6.62-37.09s23.85-47.69 12.59-78.83c0 0-2.65-26.5 11.26-39.08 10.69-9.67 30.36-63.11 38.91-87.37-1.76-7.08-3.13-11.99-3.13-11.99zM605.22 561.95s-6-39.74.66-59c5-14.39 8.06-64.05 7.92-87.82 0-8-.46-13-1.29-12.86-.41.08-2.88.23-6.87.42.56 1.36.84 5.92.88 12.45.15 23.77-3 73.43-7.92 87.82-6.62 19.21-.66 59-.66 59s-2.65 26.5 2.65 37.76-9.27 96-9.27 96-.66 25.17-7.95 37.09a8.84 8.84 0 0 1-6.08 4c5.67.84 10.83.14 13.36-4 7.29-11.92 7.95-37.09 7.95-37.09s14.57-84.79 9.27-96-2.65-37.77-2.65-37.77z"
  })), React.createElement("path", {
    d: "M588 175.11l-4.64 45.7s-73.53 15.9-65.58-9.94c3.76-12.23 4-25.36 3.13-35.79-.23-2.82-.52-5.44-.85-7.79a111.52 111.52 0 0 0-2.28-12.06s57-43.06 54.32-13.91a47.46 47.46 0 0 0 1.05 16.47 28.24 28.24 0 0 0 4.2 9.21c4.69 6.62 10.65 8.11 10.65 8.11z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M573.16 157.8c-.53.72-1.09 1.43-1.66 2.11a39.09 39.09 0 0 1-51.44 7.4 111.52 111.52 0 0 0-2.28-12.06s57-43.06 54.32-13.91a47.46 47.46 0 0 0 1.06 16.46z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M580.71 132.71a39.08 39.08 0 0 1-78.16 0v-1.5a39.08 39.08 0 0 1 78.13 1.5z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M613.8 415.18a21.3 21.3 0 0 1-13.88 8.33l-30.44 10.65h-.07l-9.23 3.23-3.87-9.52-4.74-11.68v21.2s-58.16 4-79.26-12.89l2.42-16.92s134.47-4.64 137.78-5.3c.83-.13 1.25 4.92 1.29 12.9zM588 175.11l-4.64 45.7s-73.53 15.9-65.58-9.94c3.76-12.23 4-25.36 3.13-35.79 1.27 2.66 10.62 21.48 22.71 24.75a13.11 13.11 0 0 0 4.63.44 15.37 15.37 0 0 0 7.13-2.76c10.88-7.23 20-26.26 22-30.5 4.66 6.61 10.62 8.1 10.62 8.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M711.21 312.89c-28.48 15.24-66.24 47-66.24 47s-27.82-9.94-20.53-23.18 47-39.08 47-39.08 2-7.95-6.62-12.59-21.2-15.9-21.2-15.9-29.81 64.25-23.85 107.31-19.87 45-19.87 45l-30.44 10.65h-.07l-9.23 3.23-3.87-9.52-4.74-11.68v21.2s-67.57 4.64-83.46-17.22c0 0 14.57-58.29 10.6-80.81s-8.61-135.79-8.61-135.79l50.67-25.5s9.91 21.63 22.91 25.16a13.11 13.11 0 0 0 4.63.44 15.37 15.37 0 0 0 7.13-2.76c12.27-8.15 22.35-31.35 22.35-31.35s22.85 14.1 45.19 18.45a32.1 32.1 0 0 1 17.1 9.2c2.42 2.53 5.26 5.44 8.26 8.45 8.61 8.61 68.23 66.24 68.23 66.24s23.11 27.81-5.34 43.05z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M645.66 348.66l-8.7 9.21-2.56 2.72s-23.18 21.2-29.15 20.53-15.9-41.07-4-38.42c7.24 1.61 15.71-.93 21.23-3.18a56.17 56.17 0 0 0 5.92-2.78z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M580.71 132.71a38.9 38.9 0 0 1-9.22 25.21 5.64 5.64 0 0 1-5.25-2.51c-1.1-1.93-.64-4.35-1.37-6.43s-2.39-3.51-3.44-5.36c-2.66-4.66-1.54-11.72-6.41-14.22-2.24-1.14-4.95-.76-7.45-.34-4.91.81-9.85 2.42-14.69 3.09-5.52.78-10.49-2.81-15.94-2.89-4.86-.08-9.74 2.77-14.35 1.95a39.08 39.08 0 0 1 78.13 1.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M547.57 126.41c2.5-.41 5.21-.8 7.45.35 4.87 2.49 3.75 9.55 6.41 14.21 1.05 1.85 2.75 3.36 3.45 5.36s.27 4.5 1.37 6.43c1.59 2.79 5.9 3.2 8.73 1.54s4.41-4.71 5.48-7.73c.94-2.66 1.73-5.6 4-7.34a8.48 8.48 0 0 0 2.19-1.79 5.4 5.4 0 0 0 .52-3.06c0-6.76-1.05-12 .48-18.55 2.45-10.56 4.69-23.78-3.07-31.61a26.85 26.85 0 0 0-14.62-7.48c-5-.82-12.36 6.16-17.42 6-12.87-.51-23.73-12.43-36-8.58a25.32 25.32 0 0 0-13.22 9.73c-6 8.84-5.46 20.26-4.59 30.81a3.9 3.9 0 0 0 .67 2.25c.45.54 1.18.83 1.62 1.38a3.41 3.41 0 0 1 .5 2.46 16.55 16.55 0 0 1-1.19 5 2.06 2.06 0 0 0-.18 1.8 1.82 1.82 0 0 0 1 .68c5 1.8 10.4-1.67 15.75-1.58s10.43 3.67 15.95 2.89c4.87-.75 9.81-2.36 14.72-3.17z",
    fill: "#865a61"
  }), React.createElement("path", {
    d: "M569.49 432.17h-.07l-9.57 3.56-3.54-9.85-15-41.82 2.35-182.89a13.11 13.11 0 0 0 4.63.44 15.37 15.37 0 0 0 7.13-2.76l-2.84 180z",
    opacity: 0.05
  }), React.createElement("circle", {
    cx: 550.91,
    cy: 208.23,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 546.93,
    cy: 275.79,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 543.62,
    cy: 346.01,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 547.6,
    cy: 381.11,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M615.83 283.74h-42.4v-42.39l21.2-5.97 21.2 5.97v42.39z"
  }), React.createElement("circle", {
    cx: 548.92,
    cy: 239.36,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 595.95,
    cy: 241.35,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 544.95,
    cy: 312.22,
    r: 1.99,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M479.37 196.97s-18.55 2.65-24.51 36.43-11.92 80.81-11.92 80.81-9.94 43.72 39.72 33.1l2.65-15.24s-5 17.55-3.64-17.55 1.66-58 1.66-58z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M479.37 196.97s-18.55 2.65-24.51 36.43-11.92 80.81-11.92 80.81-9.94 43.72 39.72 33.1l2.65-15.24s-7.62 16.89-6.29-18.22 4.31-57.3 4.31-57.3z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M645.66 348.66l-8.7 9.21c-12.37-5-14.77-18.11-14.77-18.11l.32-.24a56.17 56.17 0 0 0 5.92-2.78z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M633.38 331.77l-9.89 7.33s3.27 17.84 21.81 19.83l7.95-13.91z",
    fill: "#d39999"
  }), React.createElement("path", {
    fill: "#f2f5fb",
    d: "M349.25 235.77l83.88-74.81 38.39 44.67 65.88-3.4 19.97 41.3-62.72 81.92-29.38-44.63-69.88 5.98-46.14-51.03z"
  }), React.createElement("path", {
    fill: "#dde0ed",
    d: "M550.42 243.63l-22.07 28.67-23.55 30.6-10.88 14.15-25.17-39.16-26.4 2.32-42.98 3.77-32.02-35.41-11.01-12.17 44.67-39.84 33.56-29.92 17.29 20.12 18.5 21.53 18.48-.95 42.96-2.22 16.77 34.68 1.85 3.83z"
  }), React.createElement("path", {
    fill: "#abb1d1",
    d: "M411.67 213.48l-44.32 35.09-11.01-12.17 44.67-39.84 10.66 16.92zM462.23 239.33l-3.49-21.99-23.32-27.37 16.44-3.21 18.5 21.53 18.48-.95 6.78 26.19-32.93 8.67-.46-2.87zM550.42 243.63l-22.07 28.67-11.46-17.28 31.68-15.22 1.85 3.83z"
  }), React.createElement("path", {
    fill: "#abb1d1",
    d: "M504.8 302.9l-10.88 14.15-25.17-39.16-26.4 2.32-4.79-33.11 24.67-7.77 2.96 22.62 16.69 2.59 22.92 38.36z"
  }), React.createElement("path", {
    d: "M457.54 248.31a.66.66 0 0 1-.64-.23 38.34 38.34 0 0 0-11.07-9.27.662.662 0 1 1 .64-1.16 39.67 39.67 0 0 1 11.45 9.59.66.66 0 0 1-.39 1.07z",
    fill: "#d7666f"
  }), React.createElement("path", {
    d: "M449.66 250.15a.66.66 0 0 1-.69-1l8.58-14.17a.662.662 0 0 1 1.13.69l-8.58 14.17a.66.66 0 0 1-.44.31z",
    fill: "#d7666f"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.1,
    d: "M399.39 283.1l70.82-74.96 61.46-2.99-62.75 72.48-69.53 5.47z"
  }), React.createElement("path", {
    d: "M460.82 319.47s16.56-40.63 24.51-36.41 31.13 29.55 15.24 40.63-27.16 16.36-27.16 16.36l-12.59-1.58z",
    fill: "#fdc2cc"
  }), React.createElement("path", {
    d: "M451.88 319.84s15.19-11.92 27.46 24.18l-11.57 1.66-13.25-7.95z",
    fill: "#d39999"
  }), React.createElement("path", {
    d: "M451.88 319.84s15.19-11.92 27.46 24.18l-11.57 1.66-13.25-7.95z",
    opacity: 0.05
  }));
};
UndrawLost.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawLost;